import { type ToolPostPayload, ToolType } from "@repo/app-types/entities/tool";
import type { CallEndTool } from "@repo/app-types/entities/tools/callEnd";
import type { CallTransferTool } from "@repo/app-types/entities/tools/callTransfer";
import type { CustomTool } from "@repo/app-types/entities/tools/custom";
import type { WebDocumentResearchTool } from "@repo/app-types/entities/tools/webDocumentResearch";
import type { ToolFormConfig } from "../formConfigs/baseFormConfig.js";
import { callEndToolFormConfig } from "../formConfigs/callEndToolFormConfig.js";
import { callTransferToolFormConfig } from "../formConfigs/callTransferToolFormConfig.js";
import { customToolFormConfig } from "../formConfigs/customToolFormConfig.js";
import { webDocumentResearchToolFormConfig } from "../formConfigs/webDocumentResearchToolFormConfig.js";
import { useBaseToolForm } from "./useBaseToolForm.js";

// TODO: Figure out how to type all this better
type ToolMap = {
  [ToolType.CUSTOM]: CustomTool;
  [ToolType.CALL_TRANSFER]: CallTransferTool;
  [ToolType.CALL_END]: CallEndTool;
  [ToolType.WEB_DOCUMENT_RESEARCH]: WebDocumentResearchTool;
};

const configs: {
  [T in keyof ToolMap]: ToolFormConfig<ToolMap[T]["settings"], any>;
} = {
  [ToolType.CUSTOM]: customToolFormConfig,
  [ToolType.CALL_TRANSFER]: callTransferToolFormConfig,
  [ToolType.CALL_END]: callEndToolFormConfig,
  [ToolType.WEB_DOCUMENT_RESEARCH]: webDocumentResearchToolFormConfig,
};

export function useToolForm<T extends keyof ToolMap>(params: {
  type: T;
  initialData?: ToolMap[T] | undefined;
  onSave: (data: ToolPostPayload) => Promise<void>;
}) {
  const config = configs[params.type];

  return useBaseToolForm<ToolMap[T]["settings"], any>({
    config,
    initialData: params.initialData,
    // TODO: Figure out how to type all this better
    onSave: async (data) =>
      params.onSave({ ...data, type: params.type } as ToolPostPayload),
  });
}
